export default __webpack_public_path__ + "static/media/Diana Agostinello.ce7a0e95.jpg";